module.exports = __webpack_public_path__ + "static/media/error.2db8e81f.svg";